import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 80px;
  width: 100%;
  max-width: 1170px;

  .logo {
    display: flex;
    gap: 40px;
    width: 100%;
    max-width: 478px;
    align-items: center;
    justify-content: center;
    margin-top: 32px;

    .title-logo {
      font-size: 40px;
      color: white;
      max-width: 225px;
      line-height: 48px;
    }
  }

  @media (max-width: 1180px) {
    padding: 0 16px;
  }

  @media (max-width: 791px) {
    .logo {
      margin-top: 16px;
      margin-bottom: 0;

      img {
        width: 100px;
        height: 100px;
      }
      .title-logo {
        font-size: 20px;
        line-height: 30px;
      }
    }
  }
`
